import { trackingPageSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as z from "zod/v4";

export const getTrackingPageSettings = {
  name: "getTrackingPageSettings" as const,
  input: z.object({}),
  output: trackingPageSettingsSchema.nullable(),
};
